import { z } from "zod"

export const SpidertracksPointTypeSchema = z.enum([
    "POSITION",
    "DEPARTURE",
    "ARRIVAL",
    "ATU",
    "HEARTBEAT",
])

export const SpidertracksFeatureSchema = z.object({
    type: z.literal("Feature"),
    geometry: z.object({
        type: z.literal("Point"),
        coordinates: z.tuple([z.number(), z.number()]),
    }),
    properties: z.object({
        id: z.string(),
        imei: z.string(),
        tailNumber: z.string().nullish(),
        posTime: z.string(),
        altitude: z.number().nullish(),
        speed: z.number().nullish(),
        heading: z.number().nullish(),
        pointType: SpidertracksPointTypeSchema,
        atuEvent: z.string().nullish(),
    }),
})

export type SpidertracksFeature = z.infer<typeof SpidertracksFeatureSchema>

export const SpidertracksFeedResponseSchema = z.object({
    type: z.literal("FeatureCollection"),
    features: z.array(SpidertracksFeatureSchema),
})

export type SpidertracksFeedResponse = z.infer<typeof SpidertracksFeedResponseSchema>

export const SpidertracksIntegrationRecordSchema = z.object({
    orgId: z.string(),
    email: z.string(),
    encryptedPassword: z.string(),
    createdAt: z.number(),
    updatedAt: z.number(),
})

export type SpidertracksIntegrationRecord = z.infer<typeof SpidertracksIntegrationRecordSchema>
